// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__LrhZ2","container":"Homepage_container__dIQA3","footerWrapper":"Homepage_footerWrapper__ODsoA"};